<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-row :gutter="10" style="margin: 10px 0px">
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span style="margin-left: 20px"> 数据指标： </span>
          <el-select
            v-model="dataIndex"
            placeholder="请选择"
            @change="dataIndexChange"
            size="mini"
          >
            <el-option
              v-for="item in dataIndexOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span style="margin-left: 20px"> 数据类型： </span>
          <el-select
            v-model="dataRange"
            @change="dataRangeChange"
            placeholder="请选择"
            size="mini"
            disabled
          >
            <el-option
              v-for="item in dataRangeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col
          :xs="24"
          :lg="8"
          style="padding: 6px 0"
          v-if="dataRange === 'quarter'"
        >
          <span>
            <quarter
              style="margin-left: 44px"
              :default-value="defaultQuarterValue"
              v-on:getQuarter="getQuarter"
            ></quarter>
          </span>
        </el-col>
        <el-col
          :xs="24"
          :lg="8"
          style="padding: 6px 0"
          v-if="dataRange === 'halfyear'"
        >
          <span>
            <halfYear
              style="margin-left: 44px"
              :default-value="defaultQuarterValue"
              v-on:getQuarter="getHalfYear"
            ></halfYear>
          </span>
        </el-col>
        <el-col
          :xs="24"
          :lg="8"
          style="padding: 6px 0"
          v-if="dataRange === 'year'"
        >
          <span style="margin-left: 44px"> 时间： </span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            type="year"
            v-model="times"
            value-format="yyyy"
            size="mini"
            @change="yearChange"
            :picker-options="pickerOptions"
            placeholder="选择年月"
          >
          </el-date-picker>
        </el-col>
        <el-col
          :xs="24"
          :lg="8"
          style="padding: 6px 0"
          v-if="dataRange === 'month'"
        >
          <span style="margin-left: 44px"> 时间： </span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            type="month"
            v-model="times"
            value-format="yyyy-MM"
            size="mini"
            @change="monthChange"
            :picker-options="pickerOptions"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 0px" v-if="showArea">
        <el-col align="center" style="font-size: 16px">
          各园区{{
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }}情况
        </el-col>
      </el-row>
      <el-row style="margin: 10px 0px">
        <el-col :span="24">
          <Area
            v-if="showArea && tableData.length < 10"
            :area-data="areaData"
          />
          <areaRotate
            v-else-if="showArea && tableData.length >= 10"
            :area-data="areaData"
          />
        </el-col>
      </el-row>
    </div>
    <el-link style="margin: 10px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div class="content_box_inner">
      <el-row style="margin: 10px 05px">
        <el-col :span="24">
          <el-table
            v-loading="loading"
            size="mini"
            border
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            :row-class-name="tableRowClassName"
            :data="tableData"
          >
            <el-table-column type="index" label="序号" width="50" fixed>
            </el-table-column>
            <el-table-column prop="area" label="园区" fixed> </el-table-column>
            <el-table-column label="趋势" fixed width="50">
              <template slot-scope="scope">
                <el-link type="primary" @click="showDialog(scope.row)">
                  <i style="font-size: 20px" class="el-icon-data-analysis"></i>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column
              :label="
                dataIndexOptions.find((ele) => ele.value === dataIndex).label +
                '(' +
                unit +
                ')'
              "
            >
              <el-table-column
                prop="currCount"
                sortable
                :formatter="handelFix2"
                label="本期止累计"
              >
              </el-table-column>
              <el-table-column
                prop="preCount"
                sortable
                :formatter="handelFix2"
                label="上年同期"
              >
              </el-table-column>
              <el-table-column
                prop="growthRateCount"
                sortable
                :formatter="handelFix1"
                label="同比增长(%)"
              >
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pageBox">
        <!-- <el-pagination
          class="pagePC"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <van-pagination
          class="pagePhone"
          v-model="currentPage"
          :total-items="total"
          :items-per-page="20"
          :show-page-size="3"
          @change="changePage"
          force-ellipses
        /> -->
      </div>
      <el-dialog
        :title="`${parkName} - ${
          dataIndexOptions.find((ele) => ele.value === dataIndex).label
        }`"
        :visible.sync="dialogTableVisible"
        width="90%"
        @close="closeMe"
        v-if="dialogTableVisible"
      >
        <areaContent
          v-on:changeDataIndex="changeDataIndex"
          :title="`${parkName}_${
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }`"
          :name-def="dataIndex"
          :unit-def="unit"
          :park-name-def="parkName"
          :data-index-def="dataIndex"
          :data-range-def="dataRange"
          :times-def="times"
        ></areaContent>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Area from "@/components/Echarts/area.vue";
import areaRotate from "@/components/Echarts/areaRotate1.vue";
import quarter from "@/components/dateUtils/quarter.vue";
import halfYear from "@/components/dateUtils/halfYear.vue";
import areaContent from "./areaContent";
import { export2Excel } from "@/utils/utils";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      loading: false,
      parkName: "",
      year: "",
      quarter: "",
      halfyeartime: "",
      currentPage: 1,
      page: 1,
      pageSize: 20,
      total: 0,
      exportLabel: "<<点击此处可导出报表",
      dialogTableVisible: false,
      queryData: {},
      dataIndexOptions: [
        {
          value: "工业总产值",
          label: "工业总产值",
          unit: "亿元",
        },
        {
          value: "营业收入",
          label: "营业收入",
          unit: "亿元",
        },
        {
          value: "增加值",
          label: "增加值",
          unit: "亿元",
        },
        {
          value: "实缴税金",
          label: "实缴税金",
          unit: "亿元",
        },
        {
          value: "基础设施建设本年投资额",
          label: "基础设施建设本年投资额",
          unit: "亿元",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "halfyear",
          label: "半年度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: "currQuarter", //时间类型
      dataIndex: "工业总产值", //数据指标
      unit: "亿元",
      dataRange: "quarter", //数据类型
      times: "", //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      },
    };
  },
  components: {
    Area,
    areaRotate,
    quarter,
    areaContent,
    halfYear,
  },
  watch: {
    dataRange: function (value, oldValue) {
      this.initData();
    },
  },
  methods: {
    changePage() {
      this.page = this.currentPage;
      this.initData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.initData();
    },
    handleCurrentChange(val) {
      //跳转页
      this.page = val;
      this.initData();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    handelFix1(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else if (value === "year") {
        this.dataTpye = "all";
      } else if (value === "halfyear") {
        this.dataTpye = "currHalfYear";
      } else {
        this.dataTpye = "currMonth";
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.parkName = row.area;
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    initData() {
      const self = this;
      this.loading = true;
      this.queryData = {};
      this.queryData.name = this.dataIndex;
      this.queryData.year = this.year;
      let yearMonth;
      if (this.dataRange === "quarter") {
        if (this.quarter == "1") {
          yearMonth = `${this.queryData.year}-01`;
        } else if (this.quarter == "2") {
          yearMonth = `${this.queryData.year}-04`;
        } else if (this.quarter == "3") {
          yearMonth = `${this.queryData.year}-07`;
        } else {
          yearMonth = `${this.queryData.year}-10`;
        }
      }
      if (this.dataRange === "halfyear") {
        if (this.halfyeartime == "1" || this.halfyeartime == "2") {
          yearMonth = `${this.queryData.year}-01`;
        } else {
          yearMonth = `${this.queryData.year}-07`;
        }
      }
      if (this.dataRange === "year") {
        yearMonth = `${this.queryData.year}-01`;
      }

      if (this.dataRange == "month") {
        yearMonth = this.times;
      }
      this.queryData.page = this.page;
      this.queryData.pageSize = this.pageSize;
      this.queryData.name = encodeURI(this.queryData.name);
      console.log(this.queryData.name);
      this.$axios
        .get(
          `/business/upgrade/park/selectParkMsg?type=${this.queryData.name}&dateRange=${yearMonth}&pageNum=${this.queryData.page}&pageSize=${this.queryData.pageSize}`
        )
        .then((res) => {
          console.log(res.data);
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            pre: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit: this.unit,
          };
          this.showArea = false;
          this.loading = false;
          this.total = res.total;
          if (res.data.data) {
            res.data.data.forEach((item) => {
              const temp = {
                trend: "趋势",
                area: item.name,
                code: item.code,
              };
              this.areaData.xAxis.push(item.name);
              temp.currCount = item.currentValue;
              temp.preCount = item.lastValue;
              // temp.growthRateCount =
              //   item.sntq == 0
              //     ? 0
              //     : ((item.bqzlj - item.sntq) / item.sntq) * 100;
              temp.growthRateCount = item.prop == null ? 0 : item.prop;
              this.areaData.curr.name = "本期止累计";
              this.areaData.pre.name = "上年同期";
              this.areaData.profit.name = "同比增速";
              this.areaData.curr.data.push(temp.currCount);
              this.areaData.pre.data.push(temp.preCount);
              this.areaData.profit.data.push(temp.growthRateCount);
              this.tableData.push(temp);
            });
            setTimeout(function () {
              self.showArea = true;
            }, 5);
          }
        });
    },
    getQuarter(value) {
      this.year = value.split(",")[0].slice(0, 4);
      let temp = "";
      if (value.split(",")[0].slice(5, 7) === "01") {
        this.quarter = 1;
        temp = this.year + "-03";
      } else if (value.split(",")[0].slice(5, 7) === "04") {
        this.quarter = 2;
        temp = this.year + "-06";
      } else if (value.split(",")[0].slice(5, 7) === "07") {
        this.quarter = 3;
        temp = this.year + "-09";
      } else if (value.split(",")[0].slice(5, 7) === "10") {
        this.quarter = 4;
        temp = this.year + "-12";
      }
      this.times =
        this.defaultMonthValue > temp ? temp : this.defaultMonthValue;
      this.initData();
    },
    getHalfYear(value) {
      console.log("+++++++++++", value);
      this.year = value.split(",")[0].slice(0, 4);
      let temp = "";
      if (value.split(",")[0].slice(5, 7) === "01") {
        this.halfyeartime = 1;
        temp = this.year + "-03";
      } else if (value.split(",")[0].slice(5, 7) === "04") {
        this.halfyeartime = 2;
        temp = this.year + "-06";
      } else if (value.split(",")[0].slice(5, 7) === "07") {
        this.halfyeartime = 3;
        temp = this.year + "-09";
      } else if (value.split(",")[0].slice(5, 7) === "10") {
        this.halfyeartime = 4;
        temp = this.year + "-12";
      }
      this.times =
        this.defaultMonthValue > temp ? temp : this.defaultMonthValue;
      console.log(this.times);
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      this.times = this.defaultMonthValue;
      this.year = year;
      //下面是几个if
      if (month >= 1 && month <= 3) {
        this.quarter = 1;
        this.halfyeartime = 1;
        return year + "-" + "01" + "," + year + "-" + "03";
      } else if (month >= 4 && month <= 6) {
        this.quarter = 2;
        this.halfyeartime = 2;
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        this.quarter = 3;
        this.halfyeartime = 3;
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        this.quarter = 4;
        this.halfyeartime = 4;
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    yearChange(value) {
      this.times = value + "-12";
      this.times =
        this.defaultMonthValue > this.times
          ? this.times
          : this.defaultMonthValue;
      this.year = value;
      this.initData();
    },
    monthChange(value) {
      console.log("66666", value);
      this.times = value;
      this.initData();
    },
    dataIndexChange(value) {
      this.unit = this.dataIndexOptions.find((ele) => ele.value === value).unit;
      this.initData();
    },
    changeDataIndex(value) {
      if (value) {
        this.dataIndex = value;
      }
    },
    exportData() {
      let column = [
        {
          title: "园区",
          key: "area",
          rowspan: 2,
        },
        {
          title:
            this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
              .label +
            "(" +
            this.unit +
            ")",
          data: [
            {
              title: "本期止累计",
              toFixed: 2,
              key: "currCount",
            },
            {
              title: "上年同期",
              toFixed: 2,
              key: "preCount",
            },
            {
              title: "同比增长(%)",
              toFixed: 1,
              key: "growthRateCount",
            },
          ],
          colspan: 3,
        },
      ];
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.times.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        let quarter = "";
        if (parseInt(this.times.slice(5, 7)) < 4) {
          quarter = "1";
        } else if (parseInt(this.times.slice(5, 7)) < 7) {
          quarter = "2";
        } else if (parseInt(this.times.slice(5, 7)) < 10) {
          quarter = "3";
        } else if (parseInt(this.times.slice(5, 7)) < 13) {
          quarter = "4";
        }
        timeStr = this.times.slice(0, 4) + "年第" + quarter + "季度";
      }
      export2Excel(
        column,
        this.tableData,
        this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
          .label +
          "_" +
          timeStr
      );
    },
  },
  created() {
    this.$axios
      .get("/business/workBench/searchParkReportSetting?code=003")
      .then((res) => {
        let dateType = res.data.reportCycle;

        if (dateType == 0) {
          this.dataRange = "month";
        } else if (dateType == 1) {
          this.dataRange = "quarter";
        } else if (dateType == 2) {
          this.dataRange = "halfyear";
        } else {
          this.dataRange = "year";
        }
      });
    this.defaultQuarterValue = this.getNowQuarter();
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>
